import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import Segmented from '../components/SegmentedDisplay'
import MultiItemCarousel from '../components/partners/MultiItemCarousel';



const Segment = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Corporate Social Investment (CSI)' text='Empowering communities through impactful CSI initiatives.' />
            <Segmented />
            <MultiItemCarousel />
            <Banner />
            <Footer />
        </div>
    )
}

export default Segment